import './index.css';

export type {IconHighlightProps, IconHighlightLinkProps} from './IconHighlight';
export {default as default} from './IconHighlight';
